// 24px minimum target height (WCAG 2.5.8); line-height keeps text centred.
const footerLink = {
  display: 'inline-block',
  minHeight: 24,
  lineHeight: '24px',
  color: 'inherit',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
};

export default {
  footerContainer: {
    textAlign: 'center',
    margin: '20px 0',
    // Room for a fixed action bar (set by useFixedActionBarReserve).
    paddingBottom: 'var(--fixed-action-bar-h, 0px)',
    '& p': {
      fontSize: '.8em',
    },
  },
  footerContainerMargin: {
    marginTop: '50px',
  },
  footerPrivacyLinksContainer: {
    maxWidth: '500px',
    textAlign: 'center',
    margin: '20px auto 10px',
    '& hr': {
      marginBottom: '10px',
    },
  },
  footerPrivacyLinkSpan: {
    display: 'inline-block',
    padding: '2px 20px',
    fontSize: '0.8em',
    '& a': footerLink,
  },
  footerHelp: {
    margin: '0 auto',
    padding: '2px 20px',
    fontSize: '0.8em',
    '& a': footerLink,
  },
  footerTosLink: {
    // Matches the surrounding <a> tags visually; MUI resets some default
    // <button> styling when Link is rendered as component="button", so the
    // reset is undone here to keep it visually identical to the other links.
    ...footerLink,
    font: 'inherit',
    lineHeight: '24px',
    // MUI Link sets position: relative, which would paint above a fixed bar.
    position: 'static',
    verticalAlign: 'baseline',
  },
};
